/**
 * The heat marker (#65). The brand manual makes it mandatory: The Crave, and any pizza carrying hot
 * honey, is marked SPICY wherever it is offered or described — beside the name, in words. Colour
 * alone is not allowed, so the word is always there and the flame is decoration a screen reader and
 * a black-and-white ticket both do without.
 */
export function Spicy({ size = 'md' }: { size?: 'sm' | 'md' }) {
  const small = size === 'sm';
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: small ? '1px 6px' : '2px 8px',
        borderRadius: 999,
        background: '#FDECEC',
        color: '#C81B22',
        fontSize: small ? 11 : 12,
        fontWeight: 700,
        letterSpacing: '.06em',
        lineHeight: 1.6,
        whiteSpace: 'nowrap',
      }}
    >
      <span aria-hidden="true">🌶</span>
      SPICY
    </span>
  );
}
